import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
const Cashflow = (params) => {
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content">
          <div className="container px-0">
            <div className="row">
              <div class="col-md-12">
                <div className="shadowclass mt-3">
                  <div class="inventory_summary_master">
                    <div class="row-fluid">
                      <div class="col-12">
                        <div class="counts date_new_Cont">
                          <h4 class="event-alert">Select Your Period</h4>

                          <div class="half_new_div d-flex">
                            <a href="#_" class="date_label">
                              <i class="iconSprites arrow-left"></i>{" "}
                            </a>{" "}
                            <span class="date-text">
                              May 1, 2022 - May 12, 2022
                            </span>
                            <span class="clander_icon"></span>
                          </div>

                          <div class="half_right_div">
                            <ul class="summary_filter add">
                              <li class="active">
                                <a href="/finance_summary/pandl/timeLimit:month">
                                  Month
                                </a>{" "}
                              </li>
                              <li class="">
                                <a href="/finance_summary/pandl/timeLimit:quarter">
                                  Quarter
                                </a>{" "}
                              </li>
                              <li class="">
                                <a href="/finance_summary/pandl/timeLimit:year">
                                  Year
                                </a>{" "}
                              </li>
                            </ul>
                            <a href="#" class="print-cammond invent-print"></a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="accordion" id="accordionPanelsStayOpenExample">
              <div className="accordion-item">
                <h2 className="accordion-header" id="panelsStayOpen-headingOne">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseOne"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseOne"
                  >
                    <div className="col d-flex align-items-center justify-content-between">
                      <h4 className="event-alert p-0 mb-0">Cashflow</h4>
                    </div>{" "}
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseOne"
                  className="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-headingOne"
                >
                  <div className="row mx-0">
                    <div className="shadowclass mt-0">
                        <div className="table-responsive">
                          <table
                            class="checklist-table"
                            cellspacing="0"
                            cellpadding="0"
                          >
                            <thead>
                              <tr class="text-right-flow">
                                <th></th>
                                <th>August 2022F</th>
                                <th>July 2022E</th>
                                <th>June 2022</th>
                                <th>May 2022</th>
                                <th>April 2022</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <strong>Sources of Cash</strong>
                                </td>
                                <td class="align-right">
                                  <strong>$0.00</strong>
                                </td>
                                <td class="align-right">
                                  <strong>$0.00</strong>
                                </td>
                                <td class="align-right">
                                  <strong>$0.00</strong>
                                </td>
                                <td class="align-right">
                                  <strong>$0.00</strong>
                                </td>
                                <td class="align-right">
                                  <strong>$0.00</strong>
                                </td>
                              </tr>
                              <tr>
                                <td>Net Income</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                              </tr>
                              <tr>
                                <td> Depreciation/Amortization</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                              </tr>
                              <tr class="">
                                <td>Increase in Accounts Payable</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                              </tr>
                              <tr class="">
                                <td>Decrease in Accounts Receivable </td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                              </tr>
                              <tr class="">
                                <td> Decrease in Inventory </td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                              </tr>
                              <tr class="">
                                <td> New Loans </td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                              </tr>
                              <tr class="">
                                <td>New Investment</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                              </tr>
                              <tr class="">
                                <td>Sales Tax Collected</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                              </tr>
                              <tr class="">
                                <td>Sales of Assets</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                              </tr>
                              <tr class="border_Top">
                                <td>
                                  <strong>Use of Cash </strong>
                                </td>
                                <td class="align-right">
                                  <strong>($0.00)</strong>
                                </td>
                                <td class="align-right">
                                  <strong>($0.00)</strong>
                                </td>
                                <td class="align-right">
                                  <strong>($0.00)</strong>
                                </td>
                                <td class="align-right">
                                  <strong>($0.00)</strong>
                                </td>
                                <td class="align-right">
                                  <strong>($0.00)</strong>
                                </td>
                              </tr>
                              <tr class="">
                                <td>Increase in Accounts Payable</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                              </tr>
                              <tr class="">
                                <td>Decrease in Accounts Receivable </td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                              </tr>
                              <tr class="">
                                <td>Decrease in Inventory</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                              </tr>
                              <tr class="">
                                <td>Repay Loans</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                              </tr>
                              <tr class="">
                                <td>Purchase Other Assets</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                              </tr>
                              <tr class="">
                                <td>Distributions</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                              </tr>
                              <tr class="">
                                <td>Sales Tax Payment</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                                <td class="align-right">$0.00</td>
                              </tr>
                              <tr class="border_Top border_bottom actual_cost_row">
                                <td class="text-green">
                                  <strong>Net Cashflow </strong>
                                </td>
                                <td class="text-green align-right">
                                  <strong>$0.00 </strong>
                                </td>
                                <td class="text-green align-right">
                                  <strong>$0.00 </strong>
                                </td>
                                <td class="text-green align-right">
                                  <strong>$0.00 </strong>
                                </td>
                                <td class="text-green align-right">
                                  <strong>$0.00 </strong>
                                </td>
                                <td class="text-green align-right">
                                  <strong>$0.00 </strong>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default Cashflow;
